import React from "react";
import styled from "styled-components";
import { COLOR_PRIMARY, COLOR_LIGHT_BLUE } from "../../constants/color";

type Props = {
  text: string;
  onClick: () => void;
};

export const ClickableText: React.FC<Props> = ({ text, onClick }) => {
  return <StyledClickableText onClick={onClick}>{text}</StyledClickableText>;
};

const StyledClickableText = styled.span`
  color: ${COLOR_PRIMARY};
  text-decoration: underline;
  cursor: pointer;
  transition: color 0.2s ease-in-out;

  &:hover {
    color: ${COLOR_LIGHT_BLUE};
  }
`; 